/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Tag } from "../../assests/svg/Tag/tag.svg";
import UserDefaultPlaceHolder from "../../assests/img/default-user.png";
import { useDispatch, useSelector } from "react-redux";
import { clearClientList, fetchClient } from "../../Redux/Client/clientAction";
import { fetchClientMappedMerchandise } from "../../Redux/Distributions/ClientMerchandiseDistributions/ClientMerchandiseDistributionAction";
import FloatNotClient from "../Models/FloatNotClient";
import ModalComp from "../Models/ModalComp";
import { setSelectedDistMerClient } from "../../Redux/Distributions/ClientMerchandiseDistributions/ClientMerchandiseDistributionAction";
import InfiniteScroll from "react-infinite-scroll-component";
import PulseLoaders from "react-spinners/PulseLoader";
import PulseLoader from "../Loader/PulseLoader";
import { useTranslation } from "react-i18next";
import SearcBar from "../InputField/SearcBar";
import { SORT_TYPE } from "../../utils/ConstantData";
import { DataSortingHandler } from "../../utils/constantFunction";
import RefreshButton from "../Button/RefreshButton";


const MerchanDistributionTable = (props) => {
  const { clientsState } = props;
  const history = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const hasmore = useSelector((state) => state?.clients?.next_iteration);
  const loading = useSelector((state) => state?.clients?.loading);

  const [skip, setskip] = useState(
    clientsState.length === 0 ? -10 : clientsState.length - 10
  );
  const [limit, setlimit] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);

  const [searchTerm, setSearchTerm] = useState("");

  const searchHandler = (e) => {
    setSearchTerm(e.target.value);
  };

  // for table data sorting
  const [order, setOrder] = useState(SORT_TYPE?.descending);
  const [tableHeaderName, setTableHeaderName] = useState("");

  const sortingHandler = (
    tableHeaderName,
    setTableHeaderName,
    data,
    order,
    setOrder
  ) => {
    DataSortingHandler(
      tableHeaderName,
      setTableHeaderName,
      data,
      order,
      setOrder
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (clientsState.length === 0) {
      fetchdata(skip);
    }
  }, []);

  const fetchdata = () => {
    setTimeout(async () => {
      dispatch(fetchClient(skip + limit, limit, clientsState));
      setskip(skip + limit);
    }, 100);
  };

  const goTonextStep = (item) => {
    dispatch(setSelectedDistMerClient(item));
    dispatch(fetchClientMappedMerchandise(item.id));
    history("/merchandise-order", {
      state: {
        selectedClient: item,
      },
    });
  };

  const refreshData = () => {
    dispatch(clearClientList());
    setskip(0);
    setlimit(10);
    dispatch(fetchClient(0, 10, []));
  }

  return loading === true && clientsState.length === 0 ? (
    <div className="d-flex flex-column justify-content-center align-item-center">
      <h5 className="text-center">
        <PulseLoader type={"data"} />
      </h5>
    </div>
  ) : (
    <div>
      <div className="d-flex flex-column  bg-white">
        <div className="card-body d-flex  flex-row justify-content-between align-item-center">
          <div className="p-2 flex-grow-1">
            <div className="d-flex gap-3 my-2 mx-3 align-items-center">
              <Tag />
              <span className="font-20 font-bold">{t("Select Client")}</span>
              <SearcBar
                type="text"
                name="search"
                lang={props?.lang}
                placeholder={t("Search by name")}
                onChange={searchHandler}
              />
            </div>
          </div>
          <div className="d-flex flex-row justify-content-start align-items-center gap-2">
            <div>
              <RefreshButton onClick={refreshData} />
            </div>
          </div>

        </div>
        <InfiniteScroll
          dataLength={clientsState?.length || 0}
          next={fetchdata}
          hasMore={hasmore}
          loader={
            <div className="d-flex justify-content-center">
              {" "}
              <PulseLoaders
                color={"#594190"}
                loading={loading}
                size={10}
              />{" "}
            </div>
          }
        >
          <div className="row px-5 py-2">
            <table responsive="xl">
              <tbody>
                <tr className="card-body gap-3 border-bottom py-5 cursor">
                  <td
                    className={`card-body gap-1 font-13 font-bold text-muted ${tableHeaderName === "partner_name"
                      ? "ascending"
                      : "descending"
                      }`}
                    onClick={() =>
                      sortingHandler(
                        "partner_name",
                        setTableHeaderName,
                        clientsState,
                        order,
                        setOrder
                      )
                    }
                  >
                    {t("Name")}
                  </td>
                  <td className={`card-body gap-1 font-13 font-bold text-muted ${tableHeaderName === "email"
                    ? "ascending"
                    : "descending"
                    }`}
                    onClick={() =>
                      sortingHandler(
                        "email",
                        setTableHeaderName,
                        clientsState,
                        order,
                        setOrder
                      )
                    }
                  >
                    {t("Clientmail")}
                  </td>
                  <td className={`card-body gap-1 font-13 font-bold text-muted ${tableHeaderName === "country_name"
                    ? "ascending"
                    : "descending"
                    }`}
                    onClick={() =>
                      sortingHandler(
                        "country_name",
                        setTableHeaderName,
                        clientsState,
                        order,
                        setOrder
                      )
                    }>
                    {t("Country")}
                  </td>
                  <td className={`card-body gap-1 font-13 font-bold text-muted ${tableHeaderName === "state_name"
                    ? "ascending"
                    : "descending"
                    }`}
                    onClick={() =>
                      sortingHandler(
                        "state_name",
                        setTableHeaderName,
                        clientsState,
                        order,
                        setOrder
                      )
                    }
                  >
                    {t("State")}
                  </td>
                </tr>
                {clientsState &&
                  clientsState
                    ?.filter((item) => {
                      if (searchTerm === "") {
                        return item;
                      } else if (
                        item?.partner_name
                          .toLowerCase()
                          .includes(searchTerm.toLowerCase())
                      ) {
                        return item;
                      }
                    })
                    .map((item, index) => (
                      <tr
                        className="card-body gap-3 border-bottom hover-row"
                        key={item.id}
                        onClick={() => goTonextStep(item)}
                      >
                        <td className="card-body gap-1">
                          <div className="d-flex flex-row justify-content-start  gap-3">
                            <span>
                              <img
                                src={UserDefaultPlaceHolder}
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  backgroundSize: "cover",
                                }}
                                alt="Logo Not Found"
                              />
                            </span>
                            <div className="d-flex flex-column justify-content-start ">
                              <span
                                className="font-15 font-boldest text-dark d-inline-block text-truncate"
                                title={item.partner_name}
                                style={{ maxWidth: "150px" }}
                                data-toggle="tooltip"
                                data-placement="top"
                              >
                                {item.partner_name}
                              </span>
                              <span className="font-12 font-bold text-muted">
                                {item.company_name}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td className="card-body gap-1">
                          <div className="d-flex flex-row justify-content-between  gap-3">
                            <span
                              className="fs-light  text-muted d-inline-block text-truncate"
                              style={{ maxWidth: "220px" }}
                              data-toggle="tooltip"
                              data-placement="top"
                              title={item.email}
                            >
                              {item.email}
                            </span>
                          </div>
                        </td>
                        <td className="card-body gap-1">
                          <span
                            className="font-15 font-boldest text-dark d-inline-block text-truncate"
                            style={{ maxWidth: "150px" }}
                            data-toggle="tooltip"
                            data-placement="top"
                            title={
                              item.country_name
                                ? item.country_name
                                : "No country"
                            }
                          >
                            {item.country_name
                              ? item.country_name
                              : "No country"}
                          </span>
                        </td>
                        <td className="card-body gap-1">
                          <span
                            className="font-15 font-boldest text-dark d-inline-block text-truncate"
                            style={{ maxWidth: "150px" }}
                            data-toggle="tooltip"
                            data-placement="top"
                            title={
                              item.state_name ? item.state_name : "No state"
                            }
                          >
                            {item.state_name ? item.state_name : "No state"}
                          </span>
                        </td>


                      </tr>
                    ))}
              </tbody>
            </table>
            {!clientsState.length && (
              <div className="d-flex flex-row justify-content-center py-3">
                <span className="font-20 font-bold text-error">
                  {t("No client found")}
                </span>
              </div>
            )}
          </div>
        </InfiniteScroll>

        <ModalComp
          size="md"
          showModal={showModal}
          component={<FloatNotClient handleClose={handleClose} />}
        />
      </div>
    </div>
  );
};

export default MerchanDistributionTable;
